import { Children, ReactNode } from 'react';

import styled from 'styled-components';

import { Button } from '@components/button';
import { IconCheckmark } from '@components/icons/checkmark';
import { IconCloseRegular } from '@components/icons/close-regular';
import { Separator } from '@components/separator';
import { Stack } from '@components/stack';
import { useScopedTranslate } from '@locale/translate';
import { theme } from '@styles/theme';
import { pxToRem } from '@utils/converters';

export const SelectionBanner = ({
  children,
  selectedCount,
  clearSelected,
}: {
  children: ReactNode;
  selectedCount: number;
  clearSelected(): void;
}) => {
  const { t } = useScopedTranslate(locale);
  const childCount = Children.count(children);

  return (
    <SelectionHeaderContainer>
      <Stack orientation="horizontal" align="center" justify="space-between">
        <Stack orientation="horizontal" space={4} style={{ height: pxToRem(40) }}>
          <Stack orientation="horizontal" space={1} align="center">
            <Button
              text={t('nrSelected', { number: selectedCount })}
              iconLeft={<IconCheckmark color="elementBlue100" />}
              iconRight={<IconCloseRegular />}
              onClick={clearSelected}
              variant="secondary"
            />
          </Stack>

          {childCount > 0 && <Separator orientation="horizontal" />}
          {children}
        </Stack>
      </Stack>
    </SelectionHeaderContainer>
  );
};

const SelectionHeaderContainer = styled.div({
  backgroundColor: theme.color.backgroundSecondary,
  paddingTop: pxToRem(16),
  paddingLeft: pxToRem(16),
});

const locale = {
  en: {
    nrSelected: '{number} Selected',
  },
};
